var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.community
    ? _c(
        "a",
        {
          class: { active: !_vm.isHovered },
          attrs: { href: "/" + _vm.community.url },
          on: {
            mouseenter: function ($event) {
              _vm.isHovered = true
            },
            mouseleave: function ($event) {
              _vm.isHovered = false
            },
          },
        },
        [
          _vm.community.thumb
            ? _c("img", {
                staticClass: "image",
                attrs: {
                  srcset: _vm.$simpleStore.transformImageWithCloudfront(
                    _vm.width,
                    _vm.height,
                    _vm.community.thumb,
                    _vm.$root,
                    "srcset"
                  ),
                  src: _vm.$simpleStore.transformImageWithCloudfront(
                    _vm.width,
                    _vm.height,
                    _vm.community.thumb,
                    _vm.$root
                  ),
                  alt: "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            staticClass: "logo",
            attrs: {
              srcset: _vm.$simpleStore.transformImageWithCloudfront(
                _vm.logoSize,
                _vm.logoHeight,
                "img/communities/" +
                  _vm.community.community_id +
                  "/" +
                  _vm.community.image,
                _vm.$root,
                "srcset"
              ),
              src: _vm.$simpleStore.transformImageWithCloudfront(
                _vm.logoSize,
                _vm.logoHeight,
                "img/communities/" +
                  _vm.community.community_id +
                  "/" +
                  _vm.community.image,
                _vm.$root
              ),
              alt: "",
              width: _vm.logoHeight ? _vm.logoSize : null,
              height: _vm.logoHeight,
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "name",
            class: ["name", _vm.height >= _vm.width ? "portrait" : ""],
            domProps: { innerHTML: _vm._s(_vm.community.name) },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }